// extracted by mini-css-extract-plugin
export default {"dropdownContent":"IntervalContextMenu_dropdownContent__XVByP"};